import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@material-ui/core/Button";
import { Link as RouterLink } from "react-router-dom";
import { advertFormatCurrency } from "../../../../../utils";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router";
import { Skeleton } from "@material-ui/lab";
import useMobileRoutes from "../../../hooks/useMobileRoutes";
const useStyles = makeStyles((theme) => ({
    container: {
        position: "relative",
        width: "80vw",
        height: "100%",
        display: "flex",
        backgroundColor: "white",
        flexDirection: "column",
        whiteSpace: "normal",
        boxShadow: "0px 0px 5px 0px rgb(0 0 0 / 27%)",
        marginBottom: "5px",
        marginTop: "3px",
        "& button, & a": {
            padding: 0,
            margin: 0,
        },
    },
    imageContainer: {
        width: "100%",
        paddingTop: "calc(552 / 1184 * 100%)",
        position: "relative",
        "& img, & span": {
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
        },
    },
    header: {
        color: theme.palette.primary.dark,
        textAlign: "center",
        fontSize: "20px",
        fontWeight: 400,
    },
    descriptionContainer: {
        flex: "1 1 auto",
        fontSize: "12px",
        textAlign: "center",
        height: 0,
        overflowY: "auto",
        marginBottom: theme.spacing(2),
    },
    priceContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
    },
    originalPackagePrice: {
        color: "#9D9D9D",
        textDecoration: "line-through",
        fontSize: "12px",
        textAlign: "center",
    },
    justNowPackagePrice: {
        color: theme.palette.secondary.main,
        fontSize: "15px",
        textAlign: "center",
        fontWeight: 500,
    },
    packagePrice: {
        textAlign: "center",
    },
    packageButton: {
        minWidth: "50%",
        minHeight: "40px",
    },
    disabledContainer: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: theme.palette.primary.light + "aa",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    disabledText: {
        padding: "8px 20px",
        fontSize: "18px",
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
    },
}));
const PackageListItem = ({ pkg, customBannerUrl }) => {
    const classes = useStyles();
    const routes = useMobileRoutes();
    let bannerSrc = customBannerUrl !== null && customBannerUrl !== void 0 ? customBannerUrl : pkg.image;
    console.log("Package", pkg);
    // @ts-ignore
    // @ts-ignore
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", { className: classes.imageContainer },
            React.createElement("img", { src: bannerSrc, "aria-labelledby": "package_list_" + pkg.uuid })),
        React.createElement(Box, { p: 2, display: "flex", flexDirection: "column", flexGrow: 1 },
            React.createElement(Typography, { variant: "h3", className: classes.header, id: "package_list_" + pkg.uuid }, pkg.name),
            React.createElement(Box, { mb: 1, mt: 1, className: classes.descriptionContainer }, pkg.description.split(/\n/).map((line) => (React.createElement(React.Fragment, null,
                line,
                React.createElement("br", null))))),
            pkg.type == "package" && (React.createElement(Box, { display: "flex", justifyContent: "space-between" },
                React.createElement(PackagePrice, { pkg: pkg }),
                React.createElement(Button, { color: "primary", component: RouterLink, variant: "contained", className: classes.packageButton, 
                    /* @ts-ignore */
                    to: generatePath(routes["products.packages.create"].path, {
                        packageUuid: pkg.uuid,
                    }) }, pkg.linkText))),
            pkg.type == "link" && pkg.link && (React.createElement(Box, { display: "flex", justifyContent: "flex-end" },
                React.createElement(Button, Object.assign({ color: "primary", variant: "contained", className: classes.packageButton }, getPackageLink(pkg, routes)), pkg.linkText)))),
        pkg.disabled && (React.createElement("div", { className: classes.disabledContainer },
            React.createElement("div", { className: classes.disabledText }, pkg.disabled.reason)))));
};
const PackagePrice = ({ pkg }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    if (pkg.useTimeLimitedDiscount &&
        pkg.originalPrice > pkg.timeLimitedDiscountPrice) {
        return (React.createElement("div", { className: classes.priceContainer },
            React.createElement("div", { className: classes.originalPackagePrice }, t("Price: %s", {
                postProcess: "sprintf",
                sprintf: [advertFormatCurrency(pkg.originalPrice)],
            })),
            React.createElement("div", { className: classes.justNowPackagePrice }, t("Just now: %s", {
                postProcess: "sprintf",
                sprintf: [advertFormatCurrency(pkg.timeLimitedDiscountPrice)],
            }))));
    }
    if (!pkg.useTimeLimitedDiscount &&
        pkg.originalPrice > pkg.priceIncludingDiscount) {
        return (React.createElement("div", { className: classes.priceContainer },
            React.createElement("div", { className: classes.originalPackagePrice }, t("Price: %s", {
                postProcess: "sprintf",
                sprintf: [advertFormatCurrency(pkg.originalPrice)],
            })),
            React.createElement("div", { className: classes.justNowPackagePrice }, t("Package price: %s", {
                postProcess: "sprintf",
                sprintf: [advertFormatCurrency(pkg.priceIncludingDiscount)],
            }))));
    }
    if (pkg.priceIncludingDiscount > 0) {
        return (React.createElement("p", { className: classes.packagePrice }, t("Price: %s", {
            postProcess: "sprintf",
            sprintf: [advertFormatCurrency(pkg.priceIncludingDiscount)],
        })));
    }
    return null;
};
const getPackageLink = (pkg, routes) => {
    console.log("Get package", pkg);
    if (pkg.linkInfo) {
        switch (pkg.linkInfo.type) {
            case "cards":
                return {
                    to: generatePath(routes["products.cards"].path, {
                        type: pkg.linkInfo.type,
                    }),
                    component: RouterLink,
                };
            case "calendars":
                return {
                    to: generatePath(routes["products.calendars"].path, {
                        type: pkg.linkInfo.type,
                    }),
                    component: RouterLink,
                };
            case "catalogues":
                return {
                    to: generatePath(routes["products.catalogues"].path),
                    component: RouterLink,
                };
            case "digitalcopy":
                return {
                    to: generatePath(routes["products.digitalportraits"].path),
                    component: RouterLink,
                };
            case "photogifts.category":
                console.log("Generate", routes["products.photogifts.category"].path, pkg.linkInfo.category);
                return {
                    to: generatePath(routes["products.photogifts.category"].path, {
                        type: "photogifts",
                        category: pkg.linkInfo.category,
                    }),
                    component: RouterLink,
                };
            case "photogifts":
                return {
                    to: generatePath(routes["products.list"].path),
                    component: RouterLink,
                };
        }
    }
    return {
        href: pkg.link,
        component: "a",
    };
};
export const PackageListItemSkeleton = () => {
    const classes = useStyles();
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", { className: classes.imageContainer },
            React.createElement(Skeleton, { variant: "rect" })),
        React.createElement(Box, { p: 2, display: "flex", flexDirection: "column", flexGrow: 1 },
            React.createElement(Typography, { variant: "h6", className: classes.header },
                React.createElement(Skeleton, { variant: "text" })),
            React.createElement("p", { className: "package-price" },
                React.createElement(Skeleton, { variant: "text" })),
            React.createElement(Box, { mb: 1, mt: 1, className: classes.descriptionContainer },
                React.createElement(Skeleton, { variant: "text" }),
                React.createElement(Skeleton, { variant: "text" })),
            React.createElement(Box, { display: "flex", justifyContent: "space-between" },
                React.createElement("div", { style: { flexBasis: "30%" } },
                    React.createElement(Skeleton, { variant: "text", animation: "pulse" })),
                React.createElement(Skeleton, { variant: "rect", width: "140", height: 40 })))));
};
export default PackageListItem;
